var constant = {};

var dateUtils = {
    UNITS: {
        '年': 31557600000,
        '月': 2629800000,
        '天': 86400000,
        '小时': 3600000,
        '分钟': 60000,
        '秒': 1000
    },
    humanize: function (milliseconds) {
        var humanize = '';
        for (var key in this.UNITS) {
            if (milliseconds >= this.UNITS[key]) {
                humanize = Math.floor(milliseconds / this.UNITS[key]) + key + '前';
                break;
            }
        }
        return humanize || '刚刚';
    },
    format: function (dateStr) {
        var date = this.parse(dateStr);
        var diff = Date.now() - date.getTime();
        if (diff < this.UNITS['天']) {
            return this.humanize(diff);
        }
        var _format = function (number) {
            return (number < 10 ? ('0' + number) : number);
        };
        return date.getFullYear() + '/' + _format(date.getMonth() + 1) + '/' + _format(date.getDate()) + '-' +
            _format(date.getHours()) + ':' + _format(date.getMinutes());
    },
    parse: function (str) { //将"yyyy-mm-dd HH:MM:ss"格式的字符串，转化为一个Date对象
        var a = str.split(/[^0-9]/);
        return new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]);
    }
};

const isEmpty = (obj) => {
    if (obj === null || obj === undefined || obj === 0 || obj === false || obj === {} || obj === []) {
        return true;
    }
    if (typeof obj === 'string') {
        if (obj.trim() === '' || obj.trim() === 'null' || obj.trim() === 'undefined') {
            return true;
        }
    }
    return false;
};

function formatTime(time) {
    if (typeof time !== 'number' || time < 0) {
        return time
    }

    var hour = parseInt(time / 3600);
    time = time % 3600;
    var minute = parseInt(time / 60);
    time = time % 60;
    var second = time;

    return ([hour, minute, second]).map(function (n) {
        n = n.toString();
        return n[1] ? n : '0' + n
    }).join(':')
}

function formatLocation(longitude, latitude) {
    if (typeof longitude === 'string' && typeof latitude === 'string') {
        longitude = parseFloat(longitude);
        latitude = parseFloat(latitude)
    }

    longitude = longitude.toFixed(2);
    latitude = latitude.toFixed(2);

    return {
        longitude: longitude.toString().split('.'),
        latitude: latitude.toString().split('.')
    }
}

const getUrlParam = (name) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null && r !== 'null') {
        return decodeURI(r[2]);
    } else {
        return null;
    }
};

const {request} = require("./request");
const {verify} = require("./verify");

module.exports = {
    formatTime: formatTime,
    formatLocation: formatLocation,
    dateUtils: dateUtils,
    isEmpty: isEmpty,
    getUrlParam: getUrlParam,
    constant: constant,
    request: request,
    verify: verify,
};